document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".product-tabs .tab-links li");
  const contents = document.querySelectorAll(".product-tabs .tab-content");

  console.log("tabs:", tabs.length, "contents:", contents.length);

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      const target = this.getAttribute("data-tab");

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      const contentDiv = document.getElementById(target);
      if (contentDiv) contentDiv.classList.add("active");
    });
  });
});